import React from 'react';
// ---------------  For Ui ----------------------------------
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import { Redirect } from 'react-router-dom'
// ---------------  For Redux ----------------------------------
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { createNavigation, createNavigationReset } from '../../store/actions/NavigationActions'
import FormPicker from '../custom/FormPicker'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const styles = theme => ({
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
  },
  avatar: {
    margin: theme.spacing,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing,
  },
  submit: {
    marginTop: theme.spacing(3),
  },
});

class CreateNavigation extends React.Component {

  state = {
    title: '',
    path: '',
    AdminSelectable: false,
    ShowMe: false,
    AnyUser:false
  }

  componentWillReceiveProps() {
    console.log("this.props.navigation : ", this.props.navigation, this.props.navigations)
    this.setState({
      title: this.props.navigation.title || '',
      path: this.props.navigation.path || '',
      AdminSelectable: this.props.navigation.AdminSelectable || false,
      ShowMe: this.props.navigation.ShowMe || false
    })
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();

    const { form, path } = this.state;
    if (form && form.id) {
      const newData = { ...this.state, path: '/dynamic' + path + '/' + form.id }
      this.props.createNavigation(newData)
    } else {
      this.props.createNavigation(this.state)
    }

  }

  handleToggle = (e) => {
    console.log('e : ', e)
    this.setState({
      [e.target.id]: !this.state[e.target.id]
    })
  }

  selectedForm = (form) => {
    this.setState({ form });
  }

  render() {

    console.log("auth :  ", this.props.auth)

    const { classes, auth, navigationData, history, createNavigationReset } = this.props;
    const { navigation, error } = navigationData;

    if (navigation) {
      history.push('/');
      createNavigationReset();
      return null;
    }

    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout} style={{ maxWidth: '80%', margin: 'auto' }}>
          <Paper className={classes.paper} square={false}>
            <Typography variant="h4">Create new navigation</Typography>
            <form className={classes.form} onSubmit={this.handleSubmit} >
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="title">Title</InputLabel>
                <Input
                  onChange={this.handleChange}
                  value={this.state.title}
                  id="title" name="title" autoComplete="text" autoFocus />
              </FormControl>

              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="path">Path</InputLabel>
                <Input
                  onChange={this.handleChange}
                  name="path"
                  type="text"
                  id="path"
                  value={this.state.path}
                />
              </FormControl>

              <FormControlLabel
                control={<Switch id="AdminSelectable" checked={this.state.AdminSelectable} onChange={this.handleToggle} name="AdminSelectable" />}
                label="Admin Selectable"
              />

              <FormControlLabel
                control={<Switch id="ShowMe" checked={this.state.ShowMe} onChange={this.handleToggle} name="ShowMe" />}
                label="ShowMe"
              />

            <FormControlLabel
                control={<Switch id="AnyUser" checked={this.state.AnyUser} onChange={this.handleToggle} name="AnyUser" />}
                label="Any User"
              />



              <FormControl margin="normal" required fullWidth>
                <FormPicker onChange={this.selectedForm} label="Select Form" />
              </FormControl>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Create
            </Button>
              {error ? <div>  <br /> <Typography component="p" color="error" align="center"> {error.message}</Typography> </div> : null}
            </form>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}
CreateNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapDispatchToProps = dispatch => {
  return {
    createNavigation: (navigation) => dispatch(createNavigation(navigation)),
    createNavigationReset: () => dispatch(createNavigationReset())
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id
  const navigations = state.firestore.data.navigations
  const navigation = navigations ? navigations[id] : null

  return {
    auth: state.firebase.auth,
    navigationData: state.navigation,
    navigation: { ...navigation, id }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect([
    { collection: 'navigations' }
  ])
)(withStyles(styles)(CreateNavigation));